<mat-nav-list id="fasteners-set-list" class="flex-1">
  <mat-list-item
    *ngFor="let item of sets"
    (click)="selectSet(item)"
    data-testid="fastenerSet"
    [ngClass]="{ 'last-selected': lastSelectedId === item.id }">
    <div matLine>
      <div class="flex flex-row space-x-3 items-center">
        <img
          *ngIf="item.imageLink"
          class="fasteners-set-icon"
          [src]="getFastenersSetIconLink(item.id)"
          alt="Fastener set icon" />
        <div>{{ item.name }}</div>
        <div>
          <button mat-icon-button (click)="$event.stopPropagation(); openFastenersSchemaDialog(item.holes, item.type)">
            <mat-icon>help_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </mat-list-item>
</mat-nav-list>
